module.exports = __webpack_public_path__ + "static/media/simpplrGradient.51b1113a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/simpplrGradient.png
// module id = 18
// module chunks = 0